import * as Sentry from '@sentry/react';

export const INVALID_RESPONSE_ERROR_CODE = 'invalid_response';

export class InvalidResponseError extends Error {
  status: number;

  contentType: string | null;

  responsePreview: string;

  constructor(message: string, status: number, contentType: string | null, responseText: string) {
    super(message);
    this.name = 'InvalidResponseError';
    this.status = status;
    this.contentType = contentType;
    this.responsePreview = responseText.substring(0, 500);
    Object.setPrototypeOf(this, InvalidResponseError.prototype);

    // Log to Sentry for monitoring
    Sentry.captureMessage('API returned HTML instead of JSON', {
      level: 'error',
      extra: {
        status,
        contentType,
        responsePreview: this.responsePreview,
      },
    });
  }
}
